/*
    global $, EQLAPP, popWin, popWinClose,
    confirmationPopup, submitCreditNote, createLoader, ajaxGetFunction
*/

'use strict';

let rowDetails = {};

export function InvoiceGrid(selector, ownerId, allowCredit) {

    var fromDate = $('#sageInvoiceDateFrom').val();
    var toDate = $('#sageInvoiceDateTo').val();
    rowDetails = {};

    $(selector).jqGrid({
        url: '/components/sageAPI.cfc?' + $.param({
            'method': 'getInvoices',
            'jqGrid': true,
            'ownerId': ownerId,
            'fromDate': fromDate,
            'toDate': toDate,
        }),
        caption: '',
        autowidth: false,
        width: 710,
        datatype: 'json',
        sortorder: 'desc',
        height: 500,
        pager: '#OwnerInvoice_pager',
        colNames: [
            'id',
            'Date',
            'Type',
            'Document No',
            'Quantity',
            'Amount',
            'Balance',
            'Status',
            'Credit',
        ],
        colModel: [
            {name: 'id', key: true, hidden: true},
            {name: 'date'},
            {name: 'transaction_type.displayed_as'},
            {name: 'document_number'},
            {name: 'total_quantity', hidden: true, formatter: 'number', align: 'right'},
            {name: 'total_amount', formatter: 'number', align: 'right'},
            {name: 'outstanding_amount', formatter: 'number', align: 'right' },
            {name: 'status.displayed_as'},
            {
                name: 'credit',
                hidden: !allowCredit,
                cellattr: function (a,b,c,d,e){
                    if (e['transaction_type.displayed_as'] == 'Sales Invoice' &&
                        e['status.displayed_as'] !== 'Paid') {
                        return 'class="creditNote option edit"';
                    } else {
                        return '';
                    }
                },
            },
        ],
        onCellSelect: function (rowid,iCol,cellcontent,e){
            var rowData = $(selector).getRowData(rowid);
            if ($(e.srcElement).hasClass('creditNote')
                && rowData['transaction_type.displayed_as'] == 'Sales Invoice') {
                var ownerId = $('#owner_id').val();
                createCreditPopup(ownerId, rowid);
            }
        },
        beforeProcessing: function (data) {
            var rows = data.ROWS, l = rows.length, i, item;
            for (i = 0; i < l; i++) {
                item = rows[i];
                if (item.credit_note_lines) {
                    rowDetails[item.id] = item.credit_note_lines;
                } else if (item.invoice_lines) {
                    rowDetails[item.id] = item.invoice_lines;
                }
            }
        },
        subGrid: true,
        subGridRowExpanded: function (subgridId, rowid) {

            var hideCredit = ($(this).getRowData(rowid)['status.displayed_as'] == 'Paid' ||
            $(this).getRowData(rowid)['transaction_type.displayed_as'] == 'Sales Credit Note' ||
            allowCredit == false);

            var credit = $(this).getRowData(rowid)['transaction_type.displayed_as'] ==
                'Sales Credit Note';

            var subgridTableId = subgridId + '_t';
            var parentRowId = rowid;

            $('#' + subgridId).html("<table id='" + subgridTableId + "'></table>");
            $('#' + subgridTableId).jqGrid({
                datatype: 'json',
                url: 'components/sageAPI.cfc?' + $.param({
                    'method': 'getInvoiceSubGrid',
                    'jqGrid': true,
                    'tranactionId': rowid,
                    'credit': credit,
                }),
                colNames: [
                    'invoiceLineId',
                    'Horse',
                    'Description',
                    'Ledger Account',
                    'Amount',
                    'Credit',
                ],
                colModel: [
                    {name: 'id', key: true, hidden: true},
                    {name: 'HORSENAME'},
                    {name: 'description', width: 130},
                    {name: 'ledger_account.displayed_as', width: 100},
                    {name: 'total_amount', width: 60, formatter: 'number', align: 'right'},
                    {
                        name: 'credit',
                        width: 40,
                        classes: 'creditNote option edit',
                        hidden: hideCredit,
                    },
                ],
                onCellSelect: function (rowid, iCol, cellcontent, e) {
                    if ($(e.srcElement).hasClass('creditNote')) {
                        var ownerId = $('#owner_id').val();
                        createCreditPopup(ownerId, parentRowId, rowid);
                    }
                },
                height: '100%',
                autowidth: false,
                width: 650,
                sortname: 'name',
                pager: 'sageInvoiceSubgrid_pager',
                rowNum: 10,
            });
        },
    });
}

export function InvoiceErrorCheck() {

    $('#invoiceErrorCheck').jqGrid({
        url: '',
        autowidth: false,
        width: 350,
        datatype: 'json',
        height: 200,
        colNames: ['Invoice Issues Found'],
        colModel: [
            {name: 'ERROR'},
        ],
        beforeProcessing: function (data) {

            if (data.ROWS.length > 0 &&
                $('input[name=Package]:checked').val() == 'SageOnline') {

                $('#btnExportInvoices').button({disabled: true});
                $('#invoiceErrorCheckContainer').customShow();
                $('.invoiceErrorMessage').customShow();

            } else {

                $('#btnExportInvoices').button({disabled: false});
                $('#invoiceErrorCheckContainer').customHide();
                $('.invoiceErrorMessage').customHide();

            }

        },
    });
}

export function createCreditNotePopup(ownerId) {
    popWin({
        popID: 'createCreditNote',
        title: 'Credit Note',
        modal: true,
        page: 'pages/ajax_sage_credit_note.cfm?ownerId=' + ownerId,
        buttons: {
            'Submit': function () {
                submitCreditNote();
            },
            'Cancel': function () {
                popWinClose('createCreditNote');
            },
        },
    });
}

export function creaditNoteSaved() {
    popWinClose('createCreditNote');
    $('#sageInvoiceGrid').trigger('reloadGrid');

}

export function createInvoicePopup(ownerId) {
    var url = 'pages/ajax_sage_create_invoice.cfm';
    if (ownerId !== undefined) {
        url = url + '?OwnerId=' + ownerId;
    }
    popWin({
        popID: 'createSageInvoice',
        title: 'Create Invoice',
        modal: true,
        page: url,
        zIndex: 997,

    });
}

export function createCreditPopup(ownerId, transactionId,invoiceLineId) {
    if (!transactionId) {transactionId = '';}
    if (!ownerId) {ownerId = '';}
    if (!invoiceLineId) {invoiceLineId = '';}
    var url = 'pages/ajax_sage_create_invoice.cfm?credit=true&' + $.param({
        ownerId: ownerId,
        transactionId: transactionId,
        invoiceLineId: invoiceLineId,
    });

    popWin({
        popID: 'createSageInvoice',
        title: 'Create Credit Note',
        modal: true,
        page: url,
        zIndex: 997,
    });
}

export function massImportNominalCodes() {
    confirmationPopup({
        title: 'Import Nominal Codes',
        contents: 'Are you sure you want to import codes from Sage?',
        yes: function () {
            createLoader('#sageLoader', 'Importing...');
            ajaxGetFunction({
                component: 'sageAPI',
                function: 'massImportNominalCodes',
                onSuccess: function (result) {
                    if (result) {
                        location.reload();
                    } else {
                        EQLAPP.STRIPE.showAlert({
                            title: 'Error',
                            body: 'Error while importing from Sage, Please try again.',
                        });
                    }
                },
            });
        },
    });
}

export function massImportTaxCodes() {
    confirmationPopup({
        title: 'Import Tax Codes',
        contents: 'Are you sure you want to import codes from Sage?',
        yes: function () {
            createLoader('#sageLoader', 'Importing...');
            ajaxGetFunction({
                component: 'sageAPI',
                function: 'massImportTaxCodes',
                onSuccess: function (result) {
                    if (result) {
                        location.reload();
                    } else {
                        EQLAPP.STRIPE.showAlert({
                            title: 'Error',
                            body: 'Error while importing from Sage, Please try again.',
                        });
                    }
                },
            });
        },
    });
}